export function adjustBackgroundBannerOffset() {
  const backgroundBannerSelectors = [
    '.google-buds-bg-banner',
    '.google-buds-bg-banner-left',
    '.lotriver-bg-left',
    '.lotriver-bg-right',
  ];
  const header = document.querySelector('[data-lotriver-header]');
  const headerOffset = header
    ? header.getBoundingClientRect().top + header.clientHeight
    : 0;
  const offsetTop = Math.max(0, Math.round(headerOffset));
  const height = `${window.innerHeight - offsetTop}px`;
  const top = `${offsetTop}px`;

  backgroundBannerSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(node => {
      if (!(node instanceof HTMLElement)) return;

      const { style } = node;
      style.height = height;
      style.top = top;
    });
  });
}
